import { Button, ActionIcon, Tooltip } from "@mantine/core";
import { SlidersHorizontal } from "lucide-react";

interface SortFilterReportButtonProps {
    onClick: () => void;
}

export function SortFilterReportButton({ onClick }: SortFilterReportButtonProps) {
    return (
        <>
            <Tooltip label="Sort & Filter">
                <ActionIcon
                    variant="light"
                    color="gray"
                    size="lg"
                    onClick={onClick}
                    hiddenFrom="sm"
                >
                    <SlidersHorizontal size={18} />
                </ActionIcon>
            </Tooltip>
            <Button
                variant="light"
                color="gray"
                leftSection={<SlidersHorizontal size={16} />}
                onClick={onClick}
                visibleFrom="sm"
            >
                Sort & Filter
            </Button>
        </>
    );
}
